import { gql } from '@apollo/client';
import { ROLE_FRAGMENT } from '@features/Role/api/getRoles';

const GET_ME = gql`
  query GetMe {
    me {
      id
      auth0Id
      firstName
      lastName
      email
      pictureURL
      activityStatus
      workspaceUsers {
        workspace {
          id
          name
          status
          isPaymentActive
        }
        role {
          ...Role
        }
        isSuspended
      }
      managedTenant {
        id
        name
        isSuspended
        companyDetails {
          name
          website
          phone
          address
          country
          city
          zipCode
        }
      }
      referral {
        id
        code
        commission
        link
        deals {
          id
          name
          invoicedAmount
          paidAmount
          startDate
          endDate
          status
          totalGains
        }
      }
    }
  }

  ${ROLE_FRAGMENT}
`;

export default GET_ME;
